let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3QtHi")).then(() => parcelRequire('8owvt'));